import apiCall from "../axios";

export interface BugReportData {
  email: string;
  name: string;
  category: string;
  description: string;
  locationName?: string;
  locationId?: number;
  screenshot?: string;
  browserInfo: {
    userAgent: string;
    url: string;
    pageTitle: string;
    timestamp: string;
  };
  datadogSessionId?: string | null;
  datadogReplayUrl?: string | null;
}

export interface BugReportResponse {
  success: boolean;
  ticketId?: string;
  message: string;
  rateLimitInfo?: {
    remaining: number;
    retryAfter?: number;
  };
}

export const submitBugReport = async (data: BugReportData): Promise<BugReportResponse> => {
  try {
    console.log("Submitting bug report:", { email: data.email, name: data.name, category: data.category, descriptionLength: data.description.length });
    const response = await apiCall<{ data: BugReportResponse }>("POST", "noc/bug-report", data, undefined, 60000);
    console.log("Bug report submitted successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Error submitting bug report:", error);
    
    // Handle different error types
    if (error.response?.data?.message) {
      const enhancedError = new Error(error.response.data.message) as Error & { rateLimitInfo?: any };
      // Pass through rate limit info if available
      if (error.response.data.rateLimitInfo) {
        enhancedError.rateLimitInfo = error.response.data.rateLimitInfo;
      }
      throw enhancedError;
    } else if (error.message) {
      throw new Error(error.message);
    } else {
      throw new Error("Failed to submit bug report. Please try again.");
    }
  }
};
